export const SETTINGS_URL = 'outlookgatewayb2/mailIntelligence/v4.0/copilotUserPreferences';
